import { type InputHTMLAttributes, forwardRef } from 'react'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  borderStyle?: 'full' | 'bottom'
}

export const Input = forwardRef<HTMLInputElement, Props>(
  ({ className = '', borderStyle = 'full', ...props }, ref) => {
    const base =
      'w-full bg-transparent text-cream placeholder-mute/60 outline-none transition-all duration-300'
    const border =
      borderStyle === 'bottom'
        ? 'border-b border-haze px-0 py-2.5 focus:border-ember'
        : 'border border-haze px-5 py-3.5 rounded-xl focus:border-ember focus:shadow-sm'

    const focusStyle = borderStyle === 'full'
      ? { boxShadow: '0 0 0 3px rgba(196, 112, 90, 0.12)' }
      : undefined

    return (
      <input
        ref={ref}
        {...props}
        className={`${base} ${border} ${className}`}
        style={{ caretColor: 'var(--color-ember)', ...focusStyle, ...props.style }}
      />
    )
  }
)

Input.displayName = 'Input'
